/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccesibilidadDto } from '../../models/accesibilidad-dto';

export interface AccesibilidadControllerObtenerAccesibilidad$Params {
}

export function accesibilidadControllerObtenerAccesibilidad(http: HttpClient, rootUrl: string, params?: AccesibilidadControllerObtenerAccesibilidad$Params, context?: HttpContext): Observable<StrictHttpResponse<AccesibilidadDto>> {
  const rb = new RequestBuilder(rootUrl, accesibilidadControllerObtenerAccesibilidad.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccesibilidadDto>;
    })
  );
}

accesibilidadControllerObtenerAccesibilidad.PATH = '/api/accesibilidad/obtener-accesibilidad';
